import { createContext, useContext, useState, useEffect } from "react";
import { login, signUpApi } from "../services/auth";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [authenticated, setAuthenticated] = useState(null); // null = unresolved
  const [user, setUser] = useState(null);

  const getStoredUser = () => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  };

  useEffect(() => {
    const storedUser = getStoredUser();
    if (storedUser) {
      setAuthenticated(true);
      setUser(storedUser);
    } else {
      setAuthenticated(false);
    }
  }, []);

  const signIn = async (values) => {
    try {
      const resp = await login(values);
      if (resp.data) {
        const { accessToken, ...userData } = resp.data;
        localStorage.setItem("user", JSON.stringify(userData));
        localStorage.setItem("token", accessToken);
        setAuthenticated(true);
        setUser(userData);
        return { status: "success" };
      }
    } catch (error) {
      return {
        status: "error",
        message: error?.response?.data?.message || "Login failed",
      };
    }
  };

  const signUp = async (values) => {
    try {
      const resp = await signUpApi(values);
      if (resp.data) {
        const { accessToken, ...userData } = resp.data;
        if (userData.role !== "Demo") {
          localStorage.setItem("user", JSON.stringify(userData));
          localStorage.setItem("token", accessToken);
          setAuthenticated(true);
          setUser(userData);
        }
        return { status: "success" };
      }
    } catch (error) {
      return {
        status: "error",
        message: error?.response?.data?.message || "Signup failed",
      };
    }
  };

  const signOut = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    setAuthenticated(false);
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        authenticated,
        user,
        signIn,
        signUp,
        signOut,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
